module.exports = __webpack_public_path__ + "img/solutions2.4a5332d.png";